// LoginForm.jsx
import React, { useContext, useEffect, useState, useRef } from 'react';
import CodeInput from '../../Header&CodeInput/CodeInput';
import SocialLogin from "../SocialLogin/SocialLogin";
import { login, resetPassword, resetPasswordRequest, verifyResetCode, tgInit } from "../../../../../../http/UserAPI";
import { observer } from "mobx-react-lite";
import { Context } from "../../../../../../index";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const LoginForm = observer(({ isForgotPassword, onForgotPassword, onBackToLogin, onTGRegister, onTGLogin, onClose }) => {
  const { user } = useContext(Context);
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const [reset, setReset] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [timer, setTimer] = useState(60); // Таймер для повторного запроса кода
  const [canResend, setCanResend] = useState(false); // Можно ли отправить код заново
  const [successMessage, setSuccessMessage] = useState('');


  const [info, setInfo] = useState({
    email: '',
    password: '',
    recoveryEmail: '',
    verificationCode: '',
    new_password: '',
    repeat_new_password: '',
  });

  const [errors, setErrors] = useState({
    email: '',
    password: '',
    recoveryEmail: '',
    verificationCode: '',
    new_password: '',
    repeat_new_password: '',
  });

  const [backErrors, setBackErrors] = useState({//если запрос не удался
    error_step_0: '',
    error_step_1: '',
    error_step_2: '',
    error_step_3: '',
  });

  const resendTimerRef = useRef(null);

  const startResendTimer = () => {
    if (resendTimerRef.current) {
      clearInterval(resendTimerRef.current); // Очищаем предыдущий таймер
    }

    setCanResend(false);
    setTimer(60);

    resendTimerRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(resendTimerRef.current);
          setCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };


  const handleNextStep1_2 = async (event) => {
    event.preventDefault();
    if (!info.recoveryEmail) {
      setErrors({ recoveryEmail: 'Введите ваш E-mail' });
      return;
    }
    try {
      await resetPasswordRequest(info.recoveryEmail);
      setStep(2);
      startResendTimer(); // Запускаем таймер для запроса кода
    } catch (err) {
      setBackErrors({ error_step_1: err.response?.data?.error || 'Ошибка отправки запроса' });
    }
  };

  const handleNextStep2_3 = async (event) => {
    event.preventDefault();

    if (!info.verificationCode) {
      setErrors({ verificationCode: 'Введите код' });
      return;
    }

    try {
      const response = await verifyResetCode(info.verificationCode, info.recoveryEmail);

      if (response.status === 200) {
        setStep(3); // ✅ Если код верен, двигаемся дальше
      }

    } catch (err) {
      console.error("❌ Ошибка проверки кода:", err.response?.data?.error || err.message);

      setBackErrors({
        error_step_2: err.response?.data?.error || 'Ошибка проверки кода. Попробуйте ещё раз.'
      });

      setReset(true); // Даем возможность заново ввести код
    }
  };

  const handleResendCode = async (event) => {
    event.preventDefault(); // ⛔ Предотвращаем перезагрузку

    if (!canResend) return;

    if (!info.recoveryEmail) {
      setBackErrors({ error_resend: 'Ошибка: E-mail не указан' });
      return;
    }

    try {
      const response = await resetPasswordRequest(info.recoveryEmail);

      console.log("✅ Повторный запрос на восстановление пароля отправлен:", response);

      if (response.message) {
        setSuccessMessage(response.message); // Показываем сообщение об успешном запросе
      }

      startResendTimer(); // Запускаем таймер повторного запроса
      setBackErrors({}); // Очищаем ошибки

    } catch (err) {
      console.error("❌ Ошибка при повторной отправке запроса:", err);
      setBackErrors({
        error_resend: err.response?.data?.error || 'Ошибка при отправке запроса. Попробуйте позже.'
      });
    }
  };


  const handleNextStep3 = async (event) => {
    if (!validate()) return;
    event.preventDefault();
    try {
      await resetPassword(info.verificationCode, info.recoveryEmail, info.new_password);

      // Показываем сообщение об успешном сбросе пароля
      setSuccessMessage('Пароль успешно обновлен!');

      // Очищаем форму
      setInfo({
        email: '',
        password: '',
        recoveryEmail: '',
        verificationCode: '',
        new_password: '',
        repeat_new_password: '',
      });

      // Очищаем ошибки
      setBackErrors({});

      // Ждём 3 секунды и возвращаемся к авторизации
      setTimeout(() => {
        setSuccessMessage('');
        setStep(1);
        onBackToLogin(); // Переключаемся на форму логина
      }, 3000);

    } catch (err) {
      console.log(err);
      setBackErrors({ ...backErrors, error_step_3: err.response?.data?.error || 'Ошибка сброса пароля' });
    }
  };


  const validate = () => {
    let valid = true;
    const newErrors = { ...errors };

    if (step === 1) {


      newErrors.recoveryEmail = !info.recoveryEmail
        ? 'Пожалуйста, заполните поле E-mail.'
        : '';
    }
    else if (step === 2) {
      newErrors.verificationCode = !info.verificationCode ? 'Пожалуйста, введите код подтверждения.' : '';
      setReset(true);
    }
    else if (step === 3) {
      // Упрощённая валидация пароля: минимум 5 символов
      newErrors.password = !info.password
        ? 'Пожалуйста, заполните поле пароль.'
        : info.password.length < 5
          ? 'Пароль должен содержать минимум 5 символов.'
          : '';


      newErrors.repeat_new_password =
        !info.repeat_new_password ? 'Пожалуйста, подтвердите пароль.' : info.new_password !== info.repeat_new_password ? 'Пароли не совпадают.' : '';
    }
    if (Object.values(newErrors).some((error) => error)) valid = false;
    setErrors(newErrors);
    return valid;
  };

  const validateLoginFields = () => {//отдельная функция для валидации логин из-за костылей со степами
    const newErrors = { ...errors };
    newErrors.email = !info.email ? 'Пожалуйста, заполните поле E-mail.' : '';
    newErrors.password = !info.password ? 'Пожалуйста, заполните поле пароль.' : '';
    setErrors(newErrors);
    return !newErrors.email && !newErrors.password;
  };


  const handlePrevStep = () => setStep(step - 1);

  const handleComplete = (code) => {
    console.log('Complete code:', code);
  };


  const handleLogin = async () => {
    if (!validateLoginFields()) return;

    try {
      const response = await login(info.email, info.password);
      user.setIsAuth(true);
      user.setUser(response.body);
      // ✅ Проверяем, что теперь курсы подтягиваются
      console.log("📚 Купленные курсы:", user.purchased_courses);
      navigate(user.userHomePath);
      onClose(); // Закрываем форму после успешного входа
    } catch (err) {
      setBackErrors({
        ...backErrors,
        error_step_0: err.response?.status === 401
          ? 'Неверный e-mail или пароль.'  // Добавляем сообщение для 401
          : err.response?.data?.message || 'Ошибка при входе. Проверьте свои данные.'
      });
    }
  };

  const handleAuthSuccess = async (user) => {
    try {
      // Отправляем данные пользователя на сервер
      const serverResponse = await tgInit(user);
      console.log("Успешный ответ от сервера:", serverResponse);
      serverResponse.status === 'register' ? onTGRegister() : onTGLogin()
    } catch (error) {
      console.error("Ошибка авторизации на сервере:", error.message);
      alert("Ошибка авторизации на сервере: " + error.message);
    }
  };

  const handleAuthError = (errorMessage) => {
    alert("Ошибка: " + errorMessage);
  };

  const loginForm = (
    <div className="auth__login">
      <div className="auth__form-input">
        <label htmlFor="login-email">E-mail</label>
        <input
          id="login-email"
          type="email"
          value={info.email}
          onChange={(e) => setInfo({ ...info, email: e.target.value })}
        />
      </div>
      {errors.email && <p className="error-message text-red-500 my-2">{errors.email}</p>}
      <div className="auth__form-input password-container">
        <label htmlFor="login-password">Пароль</label>
        <input
          id="login-password"
          type={showPassword ? "text" : "password"}
          value={info.password}
          onChange={(e) => setInfo({ ...info, password: e.target.value })}
        />
        <button type="button" className="eye-button" onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
      {errors.password && <p className="error-message text-red-500 my-2">{errors.password}</p>}
      {backErrors.error_step_0 && <p className="error-message">{backErrors.error_step_0}</p>}
      <div className="auth__box">
        <button className="submit-button" type="button" onClick={handleLogin}>Войти</button>
        <button
          type='button'
          className="forgot-password"
          onClick={onForgotPassword}
        >
          Забыл пароль
        </button>
      </div>
    </div>
  );

  // Компонент восстановления пароля
  const forgotPasswordForm = (
    <div className="auth__forgot-password">
      {step === 1 && (
        <>
          <h2>Восстановить пароль</h2>
          <h3>Введите свой e-mail, который вы использовали для регистрации, и мы отправим вам инструкцию</h3>
          <div className="auth__form-input">
            <input type="email" placeholder="E-mail"
              value={info.recoveryEmail}
              onChange={(e) => setInfo({ ...info, recoveryEmail: e.target.value })}
            />
          </div>
          {errors.recoveryEmail && <p className="error-message">{errors.recoveryEmail}</p>}
          <button className="auth__login-recovery_btn" onClick={handleNextStep1_2}>Сбросить пароль</button>
          {backErrors.error_step_1 && <p className="error-message">{backErrors.error_step_1}</p>}
        </>
      )}
      {step === 2 && (
        <>
          <h2>Подтвердите код</h2>
          <h3>Введите 5-значный код, который пришел вам на e-mail</h3>
          <CodeInput length={5} reset={reset} onComplete={(v) => setInfo({ ...info, verificationCode: v })} />
          <button className="auth__login-recovery_btn" onClick={handleNextStep2_3}>Подтвердить</button>
          {backErrors.error_step_2 && <p className="error-message">{backErrors.error_step_2}</p>}

          <button
            type="button" // ⛔️ Предотвращаем перезагрузку страницы
            className="resend-code-btn"
            onClick={handleResendCode}
            disabled={!canResend}
          >
            {canResend ? 'Отправить новый код' : `Отправить новый код (${timer}с)`}
          </button>

          {backErrors.error_resend && <p className="error-message">{backErrors.error_resend}</p>}
        </>
      )}
      {step === 3 && (
        <>
          <h2>Восстановить пароль</h2>
          <h3>Введите новый пароль, и подтвердите его</h3>
          <div className="auth__form-input">
            <label htmlFor="new-password">Пароль</label>
            <input id="new-password" type="password" placeholder="введите новый пароль..."
              value={info.new_password}
              onChange={(e) => setInfo({ ...info, new_password: e.target.value })}
            />
          </div>
          {errors.new_password && <p className="error-message text-red-500 my-2">{errors.new_password}</p>}
          <div className="auth__form-input">
            <label htmlFor="confirm-password">Повтор</label>
            <input id="confirm-password" type="password" placeholder="повторите пароль..."
              value={info.repeat_new_password}
              onChange={(e) => setInfo({ ...info, repeat_new_password: e.target.value })} />
          </div>
          {errors.repeat_new_password && <p className="error-message text-red-500 my-2">{errors.repeat_new_password}</p>}
          <button className="auth__login-recovery_btn" type="button" onClick={handleNextStep3}>Готово</button>
        </>
      )}
      <button className="back_btn" type="button" onClick={step === 1 ? onBackToLogin : handlePrevStep}>
        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 1L1.42 6.00081L6 11" stroke="#6446C3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Назад
      </button>
      {backErrors.error_step_3 && <p className="error-message text-red-500 my-2">{backErrors.error_step_3}</p>}
      {successMessage && (
        <div className="success-message bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative">
          <svg className="w-6 h-6 inline-block mr-2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7"></path>
          </svg>
          {successMessage}
        </div>
      )}

    </div>

  );

  return isForgotPassword ? forgotPasswordForm : loginForm;
});

export default LoginForm;